import { render } from "./BaseMdiIcon.vue?vue&type=template&id=b7a27490&scoped=true"
import script from "./BaseMdiIcon.vue?vue&type=script&lang=js"
export * from "./BaseMdiIcon.vue?vue&type=script&lang=js"

import "./BaseMdiIcon.vue?vue&type=style&index=0&id=b7a27490&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a27490"]])

export default __exports__